import mapObject from 'map-obj'
import { serialize } from 'object-to-formdata'

export function toBody(
  body: Record<string, any> | undefined,
  multipart = false,
): FormData | Record<string, string> {
  if (typeof body === 'undefined') {
    return {}
  }
  // Sanitize the data by converting null values to "null" strings and mapping keys and values
  const sanitizedData = mapObject(body, (key, value) => [
    key.toString(),
    value === null ? 'null' : value,
  ])

  // Serialize the sanitized data to a form data string and assign the string values back to the original object
  const formData = serialize(sanitizedData, {
    allowEmptyArrays: true,
    booleansAsIntegers: true,
    dotsForObjectNotation: false,
    indices: true,
    noFilesWithArrayNotation: false,
    nullsAsUndefineds: false,
  })

  if (multipart) {
    return formData
  }

  const newBody: Record<string, any> = {}

  for (const [key, value] of formData.entries()) {
    let pointer = newBody
    const parts = key.split(/\[|\]/g).filter(Boolean)
    const isEmptyArray = key.endsWith('[]')

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i]
      const isLast = i === parts.length - 1

      if (isLast) {
        pointer[part] = isEmptyArray ? [] : value
      }
      else {
        if (!pointer[part]) {
          pointer[part] = Number.isNaN(Number(parts[i + 1])) ? {} : []
        }
        pointer = pointer[part]
      }
    }
  }

  return newBody
}
